import React from 'react';
import classNames from 'classnames';

import './progress-indicator.scss';

interface IIndicatorProps {
  active: boolean;
}

const defaultProps: IIndicatorProps = {
  active: false
};

const Indicator: React.SFC<IIndicatorProps> = ({ active }) => (
  <li
    className={classNames('c-progress-indicator__item', {
      'is-active': active
    })}
  >
    {/* {active === true ? ' x ' : ' o '} */}
  </li>
);

Indicator.defaultProps = defaultProps;

export default Indicator;



// WEBPACK FOOTER //
// ./src/components/progress-indicator/indicator.tsx